const accordionsHolders = document.querySelectorAll('.wls-js-accordions');

if (accordionsHolders && !!accordionsHolders.length) {
    accordionsHolders.forEach(holder => {
        const accordions = holder.querySelectorAll('.wls-accordion');

        accordions.forEach((accordion, index) => {
            const accordionBtn = accordion.querySelector('.wls-accordion__header');
            const panel = accordion.querySelector('.wls-accordion__panel');

            if (index === 0) {
                accordion.classList.add('show-text');
                panel.style.maxHeight = panel.scrollHeight + 'px';
            }

            accordion.addEventListener('click', () => {
                accordion.classList.toggle('show-text');
                panel.style.maxHeight = accordion.classList.contains('show-text') ? panel.scrollHeight + 'px' : null;
            });
        });
    });
}
